var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.293945,
    width: 56.9124,
    height: 56.9124,
    rx: 28.4562,
    fill: "#E60012"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17H42.5C42.8978 17 43.2794 17.1405 43.5607 17.3905C43.842 17.6406 44 17.9797 44 18.3333V39.6667C44 40.0203 43.842 40.3594 43.5607 40.6095C43.2794 40.8595 42.8978 41 42.5 41H15.5C15.1022 41 14.7206 40.8595 14.4393 40.6095C14.158 40.3594 14 40.0203 14 39.6667V18.3333C14 17.9797 14.158 17.6406 14.4393 17.3905C14.7206 17.1405 15.1022 17 15.5 17ZM29.09 28.5773L19.472 21.3173L17.5295 23.3493L29.1095 32.0893L40.481 23.3427L38.519 21.3253L29.0915 28.5773H29.09Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.479ec28f835f0075cc38d2335f4f791a.svg";
export { ForwardRef as ReactComponent };